<template>
  <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link> |
      <router-link to="/daftar">Daftar</router-link> |
       <router-link to="/absen">Absen</router-link>
  </div> -->
  <router-view />
</template>